import { trigger, state, style, transition, animate } from '@angular/animations';
import {
  Component,
  OnInit,
  ViewChild,
  ViewChildren,
  QueryList,
  Input,
  ChangeDetectorRef,
  AfterViewInit,
  ContentChild,
  TemplateRef
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { safeJsonClone } from '@ebw-monorepo/microservices-helpers/utils/parser';

@Component({
  selector: 'ebw-monorepo-table-expandable-rows',
  templateUrl: './table-expandable-rows.component.html',
  styleUrls: ['./table-expandable-rows.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ])
  ]
})
export class TableExpandableRowsComponent implements OnInit, AfterViewInit {
  @ViewChild('outerSort', { static: true }) sort: MatSort;
  @ViewChildren('innerSort') innerSort: QueryList<MatSort>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<any>>;

  /**
   * array di dati da mostrare
   */
  @Input() data: any[] = [];
  /**
   * array per la visualizzazione delle colonne tabelle principali
   */
  @Input() columnsToDisplay: { name: string; property: string }[] = [];
  /**
   * array per la visualizzazione delle colonne tabelle annidate
   */
  @Input() innerDisplayedColumns: { name: string; property: string }[] = [];
  /**
   *  chiave che permette di recuperare l'array per la tabella annidata
   *  ex: {...., elenco:[..]}
   * expandedKey = 'elenco'
   */
  @Input() expandedKey: string = '';
  /**
   * Flag per gestire la visualizzazione dell'ordinamento (sort.disabled)
   */
  @Input() showSort: boolean = true;

  @ContentChild('innerTableRowTemplate', { static: false })
  innerTableRowTemplate: TemplateRef<any>;

  @ContentChild('tableRowTemplate', { static: false })
  tableRowTemplate: TemplateRef<any>;

  expandedElement: boolean = false;
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = [];
  displayedInner: string[] = [];

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (this.data) {
      const clonedData = safeJsonClone(this.data);

      clonedData.forEach((el) => {
        el[this.expandedKey] = new MatTableDataSource(el[this.expandedKey]);
      });

      this.dataSource = new MatTableDataSource(clonedData);
    }

    //ADD TOGGLE COLUMN
    this.columnsToDisplay.push({ name: '', property: 'toggle' });

    this.displayedColumns = this.columnsToDisplay.map((column) => column.property);
    this.displayedInner = this.innerDisplayedColumns.map((column) => column.property);
  }

  ngAfterViewInit() {
    this.sort.disabled = !this.showSort;
    this.dataSource.sort = this.sort;
  }

  toggleRow(element) {
    element[this.expandedKey] && (element[this.expandedKey] as MatTableDataSource<any>).data.length
      ? (this.expandedElement = this.expandedElement === element ? null : element)
      : null;
    this.cd.detectChanges();
    this.innerTables.forEach(
      (table: MatTable<any>, index) =>
        ((table.dataSource as MatTableDataSource<any>).sort = this.innerSort.toArray()[index])
    );
  }

  applyFilter(filterValue: string) {
    this.innerTables.forEach(
      (table, index) => ((table.dataSource as MatTableDataSource<any>).filter = filterValue.trim().toLowerCase())
    );
  }
}
